<nav #primaryMenu id="navbar" class="primary-menu-container navbar-expand-lg mr-auto"
[ngClass]="{'fix': fixHeight > 0}" [ngStyle]="{'height': fixHeight > 0 ? fixHeight + 'px' : '100%'}">
    <button [ngClass]="{'navbar-toggler': true, 'collapsed': !navbarOpen }" type="button" data-toggle="collapse" data-target="#navbarCollapse" 
    (click)="toggleNavbar()" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="icon-bar top-bar"></span>
      <span class="icon-bar middle-bar"></span>
      <span class="icon-bar bottom-bar"></span>
      <span class="sr-only">Toggle navigation</span>
    </button>
  <div [ngClass]="{'collapse navbar-collapse':true, 'show': navbarOpen}" >

    <ul #menuContainer id="primaryMenuBar" class="navbar-nav">
      <li class="nav-item" *ngFor="let menuItem of menuActions;let i=index;let $last=last" (ngInit)="afterInit()" [isLast]='$last' [id]="menuItem.ActionName">
        <ng-container *ngIf="!menuItem.SubActions; else subactions">
          <a *ngIf="!menuItem.ActionCommand" class="action-group" [id]="menuItem.ActionName + '_link'">{{menuItem.ActionDisplay}}</a>
          <a *ngIf="menuItem.ActionCommand" (click)="selectMenuHeader(menuItem.ActionCommand);"  [id]="menuItem.ActionName + '_link'"
          [ngClass]="{'active':menuItem.ActionCommand == currentMenu}">{{menuItem.ActionDisplay}}</a>
        </ng-container>
        <ng-template #subactions>

          <ng-container *ngIf="!collapsed">
            <button mat-button #matMenuTrigger="matMenuTrigger" [disableRipple]="true" [matMenuTriggerFor]="menu" [matMenuTriggerData]="menuItem.ActionName"
            class="btn-menu-item arrow-down" (menuOpened)="menuOpened(menuItem.ActionName)" [id]="returnId(menuItem)">{{menuItem.ActionName}}</button>
        
            <mat-menu #menu="matMenu" [hasBackdrop]="false" [class]="primary-mat-menu">
              <ng-container *ngFor="let subMenu of menuItem.SubActions;let i=index;">
                <div *ngIf="!subMenu.ActionCommand" class="action-group" [class.first]="i == 0">{{subMenu.ActionDisplay}}</div>
                <button mat-menu-item *ngIf="subMenu.ActionCommand" class="sub-menu-item" (click)="selectMenuHeader(subMenu.ActionCommand);">{{subMenu.ActionDisplay}}</button>
              </ng-container>
            </mat-menu>
          </ng-container>

          <ng-container *ngIf="collapsed">
            <div #dp="bs-dropdown" class="btn-group res extra-menu" dropdown>
              <button dropdownToggle class="btn dropdown-cs arrow-down no-outline" [class.active]="hasActiveSubAction(menuItem)" type="button" 
                id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{menuItem.ActionName}}
              </button>
              <ul class="dropdown-menu dropdown-menu-cs" *dropdownMenu role="menu" aria-labelledby="dropdownMenu"
              [ngStyle]="{'width': auto, 'padding-top': !menuItem.SubActions[0].ActionCommand ? '0px': '4px', 'border-top': !menuItem.SubActions[0].ActionCommand ? 'none' : '1px solid rgba(0,0,0,.15)'}">
                <li *ngFor="let subMenu of menuItem.SubActions;" class="nav-item">
                  <span *ngIf="!subMenu.ActionCommand" class="dropdown-item action-group" (click)="dp.show()">{{subMenu.ActionDisplay}}</span>
                  <a *ngIf="subMenu.ActionCommand" [ngClass]="{'dropdown-item': true, 'active':subMenu.ActionCommand == currentMenu}" (click)="selectMenuHeader(subMenu.ActionCommand);">{{subMenu.ActionDisplay}}</a>
                </li>
              </ul>
            </div>
          </ng-container>
        </ng-template>
      </li>
    </ul>
    
    <div #matMenuTrigger="matMenuTrigger" 
      [hidden]="!showBtnMore" 
      class="show-more-btn" 
      title="More menu" 
      [attr.count]="hiddenActionList.length" [matMenuTriggerFor]="hiddenMatMenu" (menuOpened)="menuOpened('hidden-menu')" [matMenuTriggerData]="'hidden-menu'">
        <div class="hamburger"></div>
    </div>

    <!-- <button mat-button [matMenuTriggerFor]="menu">{{menuItem.ActionName}}</button> -->
      
    <mat-menu #hiddenMatMenu="matMenu" [xPosition]="'before'" [hasBackdrop]="false" class="primary-mat-menu">
      <ng-container *ngFor="let action of hiddenActionList;">
        <button *ngIf="!action.SubActions" mat-menu-item class="sub-menu-item">{{action.ActionDisplay}}</button>
        <button *ngIf="action.SubActions" mat-menu-item class="sub-menu-item" [matMenuTriggerFor]="subMenu">{{action.ActionName}}</button>

        <mat-menu #subMenu="matMenu" [xPosition]="'before'" class="primary-mat-menu">
          <ng-container *ngFor="let subMenu of action.SubActions;let i=index;">
            <div class="action-group" *ngIf="!subMenu.ActionCommand" [class.first]="i == 0">{{subMenu.ActionDisplay}}</div>
            <button *ngIf="subMenu.ActionCommand" mat-menu-item class="sub-menu-item" (click)="selectMenuHeader(subMenu.ActionCommand);">{{subMenu.ActionDisplay}}</button>
          </ng-container>
        </mat-menu>

      </ng-container>
      <ul #hiddenMenu class="hidden-menu" style="display: none;">

      </ul>
    </mat-menu>
  </div>
</nav>
